module.exports = __webpack_public_path__ + "static/img/scan.ea73d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/scan.png
// module id = BHiv
// module chunks = 3